import { ReactNode } from 'react'

interface ShowProps {
  children: ReactNode
  when: unknown
}

const Show = ({ children, when }: ShowProps) => {
  if (when) {
    return <>{children}</>
  }
  return null
}

export default Show
